import { Observable } from 'rxjs';
import { Advisor } from '../../interfaces/advisor/advisor.interface';

export abstract class AdvisorRepository {
  abstract getAdvisorByCode(code: string): Observable<Advisor | null>;
  abstract getAdvisorsList(): Observable<Advisor[]>;
}
